// extracted by mini-css-extract-plugin
module.exports = {"title":"common_title__3zsJA","label":"common_label__2cO8d","formLabel":"common_formLabel__1sFlh","note":"common_note__1gL0y","requestForm":"common_requestForm__1tmBE"};